export default {
  companyFeedbacksMetadata: {
    deleteFeedbackTitle: 'Удалить опрос?',
    newFeedback: 'Новый фидбэк',
    name: 'Название',
    methodology: 'Выберите методологию',
    sendDates: 'Дни отправки',
    repeatPeriod: 'Период повтора',
    chunkCount: 'Количество частей, на которые будет разбит опрос',
    appoint: 'По всем сотрудникам выбранных подразделений будет запущен сбор фидбэка',
    start: 'Запустить',
    stop: 'Остановить',
    tooltips: {
      chunkCount:
        'Количество вопросов в опросе будут разделены на равные части, которые будут отправлены в рамках одного цикла. Если количество вопросов нельзя поделить на равное количество, то остаток вопросов отобразится в финальной части опроса.',
      start: 'При запуске начнется отправка частей опросов в выбранные дни недели',
      stop: 'Отправки частей опросов из данного цикла будут продолжаться, пока опрос не будет пройден полностью, но новый цикл опросов не будет начат.',
      answered: 'Число пользователей, которые оценили данного пользователя в рамках одного цикла',
      assigned: 'Число пользователей, которым назначена оценка по данному пользователю',
      importMethodology: 'Загрузите json файл для добавления методолгии в компанию',
      addQuestions: 'Введите название методологии и нажмите “Сохранить“, чтобы добавить вопросы',
    },
    validatorsMinValue: 'Период повтора вопросов не может быть менее {minLimit} дней',
    confirmChangeActivity: {
      start: {
        title: 'Запустить опрос?',
        button: 'Да, запустить',
      },
      stop: {
        title: 'Остановить цикл?',
        button: 'Да, остановить',
      },
    },
    successMessages: {
      createFeedback: 'Фидбэк успешно создан',
      changeFeedback: 'Фидбэк успешно изменён',
      copyMethodology: 'Методология успешно скопирована',
      importMethodology: 'Методология успешно загружена',
      deleteMethodology: 'Методология успешно удалена',
      createMethodology: 'Методология успешно создана',
      changeMethodology: 'Методология успешно изменена',
      copyEntity: 'Копирование опроса успешно завершено',
      deleteEntity: 'Опрос успешно удалён',
    },
    errorMessages: {
      createFeedback: 'Не удалось создать фидбэк',
      changeFeedback: 'Не удалось изменить фидбэк',
      getFeedback: 'Не удалось получить данные о фидбэке',
      copyMethodology: 'Не удалось скопировать методологию',
      exportMethodology: 'Не удалось сформировать файл',
      importMethodology: 'Не удалось загрузить методологию',
      deleteMethodology: 'Не удалось удалить методологию',
      createMethodology: 'Не удалось создать методологию',
      changeMethodology: 'Не удалось изменить методологию',
      copyEntity: 'Не удалось скопировать опрос',
      deleteEntity: 'Не удалось удалить опрос',
    },
    evaluated: 'Оцениваемый',
    cycle: 'Цикл',
    answered: 'Ответили',
    assigned: 'Отправлено',
    errorGetData: 'Не удалось получить данные для статистики',
    createMethodologyButton: 'Создать методологию',
    importMethodologyButton: 'Загрузить методологию',
    onChangeMethodologyButton: 'Редактировать методологию',
    deleteMethodologyButton: 'Удалить методологию',
    viewMethodologyButton: 'Просмотр методологии',
    title: 'Название',
    numOfQuestions: 'Кол-во вопросов',
    description: 'Описание',
    creationDate: 'Дата создания',
    copyMethodology: 'Скопировать методологию',
    copyMethodologyTo: 'Скопировать в другую компанию',
    exportMethodology: 'Выгрузить методологию',
    deleteMethodologyTitle: 'Удалить методологию?',
    deleteMethodologyText:
      'На основе данной методологии создано несколько фидбэков. При удалении методологии фидбэки останутся активными, но данную методологию нельзя будет использовать для создания новых фидбэков.',
    questionIndex: 'Вопрос {index}',
    SCALE: 'Шкала',
    DATE: 'Дата',
    NUMBER: 'Число',
    TEXT: 'Короткий текст',
    TEXTAREA: 'Длинный текст',
    FILE: 'Файл',
    PHONE: 'Телефон',
    TIME: 'Время',
    SINGLE_CHOICE: 'Единичный выбор',
    MULTI_CHOICE: 'Множественный выбор',
    BOOLEAN: 'Да или Нет',
    dialogTitleCopy: 'Копирование в другую компанию',
    dialogSubTitle: 'Выберите компанию или несколько, куда хотите скопировать методологию',
    searchByName: 'Поиск по названию компании',
    createMethodologyTitle: 'Новая методология',
    editMethodologyTitle: 'Редактировать методологию',
    common: 'Общая методология для всех компаний',
    dialogTitle: 'Просмотр методологии',
    feedback: 'Выберите фидбэк, чтобы посмотреть результат',
    team: 'Команда',
    guest: 'Гость',
    anonymous: 'Аноним',
    evaluatedUser: 'Оцениваемый участник',
    question: 'Вопрос',
    placeholders: {
      evaluated: 'Выберите оцениваемого участника',
      feedback: 'Данный пользователь не участвует в выбранном фидбэке',
      noData: 'Опрос был остановлен принудительно, нет данных для анализа результатов',
      assessment:
        'Здесь будут отображаться опросы и результаты прохождения. Для начала оценки нажмите кнопку «Создать фидбэк».',
    },
    report: 'Сводка',
    details: 'По отдельным пользователям',
    summaryOfQuestions: 'Сводная по вопросам',
    emplStatistic: 'Сотрудников прошли опрос',
    allQuestions: 'Все',
    surveyDone: 'Опрос пройден',
    managingMethodologies: 'Управление методологиями',
    commonMethodology: 'Общая методология',
    listOfQuestions: 'Список вопросов',
    buttons: {
      createFeedback: 'Создать фидбэк',
      changeFeedback: 'Редактировать фидбэк',
    },
    tableHeaders: {
      name: 'Название',
      status: 'Статус',
      lastStart: 'Старт цикла',
      nextStart: 'Старт следующего цикла',
      count: 'Статистика',
      cycle: 'Цикл',
    },
    started: 'Запущен',
    stopped: 'Остановлен',
    copyEntity: 'Скопировать фидбэк',
    deleteEntity: 'Удалить фидбэк',
    startSurvey:
      'При запуске начнётся отправка частей опросов в выбранные дни недели. Если опрос ранее был остановлен, то начнётся новый цикл отправки, т.е. опросы начнут приходить сначала. Запланированные отправки частей опросов из предыдущего цикла будут аннулированы.',
    stopSurvey:
      'Отправки частей опросов из данного цикла будут продолжаться, пока опрос не будет пройден полностью, но новый цикл опросов не будет начат.',
  },
};
